module.exports = __webpack_public_path__ + "static/img/tutorial-tool-competitiveness-1.5eac119.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-tool-competitiveness-1.jpg
// module id = /Zy+
// module chunks = 3